import { ALL_CANDI_REQUEST_REQUEST, ALL_CANDI_REQUEST_SUCCESS, ALL_CANDI_REQUEST_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "All Action",
  result: [],
  msg: "",
  error: "",
};

const AllCandidateListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CANDI_REQUEST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ALL_CANDI_REQUEST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ALL_CANDI_REQUEST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AllCandidateListReducer;
